export const AppPermission = {
  planningProposal: "planning-proposal",
  propertyCheck: "property-check",
  reports: "reports",
} as const;

export type AppPermission = (typeof AppPermission)[keyof typeof AppPermission];

export const StaffPermission = {
  userManage: "user:manage",
  userImpersonate: "user:impersonate",
} as const;

export type StaffPermission =
  (typeof StaffPermission)[keyof typeof StaffPermission];

export type ComponentNavigationRestrictionProps = {
  navigationRestrictions?: {
    permission: AppPermission;
    onMissingPermission: () => void;
  };
};
